<ng-template cdkPortal>
  @if (visible()) {
    <section
      class="notice"
      (keydown)="onKeydown($event)"
      [class.blocking]="maintenance.blocked()"
      [attr.role]="maintenance.blocked() ? 'dialog' : 'status'"
      [attr.aria-modal]="maintenance.blocked() ? 'true' : null"
      aria-labelledby="maintenance-title"
      [cdkTrapFocus]="maintenance.blocked()"
      [cdkTrapFocusAutoCapture]="maintenance.blocked()"
    >
      <div class="card">
        <p class="brand">HobbyTS</p>
        <h1 id="maintenance-title">{{ title() }}</h1>
        @if (maintenance.blocked() && message()) {
          <p>{{ message() }}</p>
        }
        @if (maintenance.blocked() && eta()) {
          <p><span i18n="@@maintenanceEta">Estimated return:</span> {{ eta() }}</p>
        }
        <p i18n="@@maintenanceDrafts">
          Your open form stays here. Retrying checks the connection without resubmitting your request.
        </p>
        @if (maintenance.state().unavailable) {
          <p i18n="@@maintenanceStatusUnavailable">Service status is currently unavailable.</p>
        }
        <nav aria-label="Connection assistance" i18n-aria-label="@@maintenanceAssistance">
          <button type="button" (click)="retry()" cdkFocusInitial i18n="@@maintenanceRetry">Retry connection</button>
          <a [href]="maintenance.statusUrl" target="_blank" rel="noopener noreferrer" i18n="@@maintenanceOpenStatus"
            >Open service status</a
          >
          <a href="mailto:info@hobbyts.com?subject=HobbyTS%20connection%20issue" i18n="@@maintenanceEmail"
            >Email support</a
          >
          <a href="https://t.me/hobbyts911" target="_blank" rel="noopener noreferrer" i18n="@@maintenanceTelegram"
            >Telegram support</a
          >
        </nav>
        <p class="contacts">info@hobbyts.com · @hobbyts911</p>
      </div>
    </section>
  }
</ng-template>
